<template>
  <div class="content-tab port-status">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <scrollbar ref="scrollbar" class="scrollbar-body">
      <div class="describe">{{$t('port.describe')}}</div>
      <div class="title">{{$t('interfaceTitle')}}</div>
      <div class="group-table" v-if="ports.length > 0">
        <fixed-table ref="portTable" :data="ports" :use-page="false" :header-height="40">
          <div class="right-header" slot="right-header">
            <column :style="{ width: isFec ? '14%' : '20%' }">{{$t('port.portnumber')}}</column>
            <column :id="$t('port.link')" :title="getTitle($t('port.link'))" :style="{ width: isFec ? '15%' : '20%' }">{{$t('port.link')}}</column>
            <column :style="{ width: isFec ? '14%' : '20%' }">{{$t('port.state')}}</column>
            <column :style="{ width: isFec ? '14%' : '20%' }">{{$t('port.speed')}}</column>
            <column style="width: 15%;" v-if='isFec'>{{$t('port.fec')}}</column>
            <column :style="{ width: isFec ? '14%' : '20%' }">{{$t('port.flowcontrol')}}</column>
            <column style="width: 14%;" v-if='isFec'>{{$t('port.transceiver')}}</column>
          </div>
          <template slot="rows" slot-scope="props">
            <div class="link-row" @mouseenter="mouseenter(props)" @mouseleave="mouseleave(props)" :title="getTips(props.data.key)">
              <row class="right" :props="props">
                <div class="data" :style="{ width: isFec ? '14%' : '20%' }">{{getKey(props.data.key)}}</div>
                <div class="data" :style="{ width: isFec ? '15%' : '20%' }" :id="getLinktype(props.data.val)" :title="getTitle(getLinktype(props.data.val))" >
                  <div class="link-img-content" :class="getIconClass(props.data.val)">
                  </div>
                  <span class="link-content">{{getLinktype(props.data.val)}}</span>
                </div>
                <div class="data" :style="{ width: isFec ? '14%' : '20%' }">{{getStatus(props.data.val)}}</div>
                <div class="data" :style="{ width: isFec ? '14%' : '20%' }">{{getSpeed(props.data.val)}}</div>
                <div class="data" style="width: 15%;" v-if='isFec'>{{getFec(props.data.val.FEC, props.data.val.Link, props.data)}}</div>
                <div class="data" :style="{ width: isFec ? '14%' : '20%' }" :title="setTitle(props.data.val)" >{{getFcStatus(props.data.val)}}</div>
                <div class="data" style="width: 14%;" v-if='isFec'>
                  <div class="data" v-bind:class="{ detail: getViewStatus(props.data) !== '--' }" style="display:inline-block" @click="onInfoClick($event, props.data)">{{getViewStatus(props.data)}}</div></div>
              </row>
            </div>
          </template>
        </fixed-table>
      </div>
      <div class="title">{{$t('lagTitle')}}</div>
      <div class="group-table" v-if="lags.length > 0">
        <fixed-table ref="portTable" :data="lags" :use-page="false" :header-height="40">
          <div class="right-header" slot="right-header">
            <column style="width: 20%;">{{$t('group')}}</column>
            <column :id="$t('port.link')" :title="getTitle($t('port.link'))" style="width: 20%;">{{$t('port.link')}}</column>
            <column style="width: 20%;">{{$t('port.state')}}</column>
            <column style="width: 20%;">{{$t('port.speed')}}</column>
            <column style="width: 20%;">{{$t('port.flowcontrol')}}</column>
          </div>
          <template slot="rows" slot-scope="props" v-if="props.data.key > lagStartNum">
            <div class="link-row"> <!-- @mouseenter="mouseenter(props)" @mouseleave="mouseleave(props)" -->
              <row class="right" :props="props">
                <div class="data" style="width: 20%;">{{$t('lag.groupName') + ' ' + getKey(props.data.key)}}</div>
                <div class="data" style="width: 20%;">
                  <div class="link-img-content" :class="getIconClass(props.data.val)">
                  </div>
                  <span class="link-content">{{getLinktype(props.data.val)}}</span>
                </div>
                <div class="data" style="width: 20%;">{{getStatus(props.data.val)}}</div>
                <div class="data" style="width: 20%;">{{getSpeed(props.data.val)}}</div>
                <div class="data" style="width: 20%;" :title="setLagTitle(props.data)">{{getLagFcStatus(props.data)}}</div>
              </row>
            </div>
          </template>
        </fixed-table>
      </div>
    </scrollbar>
  </div>
</template>
<script>
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import utility from '../util/utility'
import config from '../config'
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters
} from 'vuex'
export default {
  name: 'PortStatus',
  components: {
    fixedTable,
    row,
    column
  },
  data () {
    return {
      ports: {},
      lags: {},
      columns: ['portnumber', 'link', 'state', 'speed', 'flowcontrol'],
      options: {
        headings: {
          portnumber: 'Port Number',
          link: 'Link',
          state: 'State',
          speed: 'Speed',
          flowcontrol: 'Flow Control'
        }
      },
      updateInterval: null,
      isShowLoading: true,
      isInfoClick: false
    }
  },
  beforeDestroy: function () {
    clearInterval(this.updateInterval)
    this.updateInterval = null
  },
  created: async function () {
  },
  watch: {
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.updateInterval)
        this.updateInterval = null
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.updateInterval)
          this.updateInterval = null
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function () {
    this.updateInterval = setInterval(() => {
      try {
        this.getData()
      } catch (err) {
        this.$log.error(err)
      }
    }, this.intervalTime)
    this.getData()
  },
  methods: {
    getData: async function () {
      let me = this
      this.axios.all([this.getPortStatus(), this.getPortConfigure(), this.getFecStatus()])
        .then(this.axios.spread(function (status, config, fec) {
          let statusDetail = status.data.result
          let configDetail = config.data.result
          let fecDetail = fec.result
          let tempPorts = []
          let tempLags = []
          let isIngroup = null
          statusDetail.forEach((item, index) => {
            let number = Number(item.key)
            me.portMap.get(number) || (me.lagGroupMap.get(number) && me.lagGroupMap.get(number).length < 1) ? isIngroup = true : isIngroup = false
            let data = {
              'key': item.key,
              'val': {
                'Link': item.val['Link'],
                'FullDuplexStatus': item.val['FullDuplexStatus'],
                'Speed': item.val['Speed'],
                'FC': configDetail[index].val['FC'],
                'Shutdown': configDetail[index].val['Shutdown'],
                'FCstatus': configDetail[index].val['FlowControlStatus'],
                'AutoMode': configDetail[index].val['AutoMode'],
                'Combo': configDetail[index].val['Combo'],
                'MediaType': configDetail[index].val['MediaType'],
                'FEC': (fecDetail[index].val.NegotiationSuccee === -1) ? 'N/A' : fecDetail[index].val.NegotiationType,
                'AutoNegotiation': configDetail[index].val['AutoNegotiation'],
                'isInGroup': isIngroup
              }
            }
            if (number <= me.portNumber) {
              tempPorts.push(data)
            } else if (number <= me.lagStartNum + me.lagGroupMap.size) {
              tempLags.push(data)
            }
          })
          me.ports = tempPorts
          me.lags = tempLags
          me.isShowLoading = false
          me.$store.commit('setPortStatus', tempPorts)
        }))
    },
    getKey: function (key) {
      let num = Number(key)
      if (num > this.portNumber) {
        return num - this.lagStartNum
      } else {
        return num
      }
    },
    getLinktype: function (type) {
      if (type.isInGroup) {
        return '--'
      } else {
        if (type.Link) {
          return this.$t('linkUp')
        } else {
          return this.$t('linkDown')
        }
      }
    },
    getIconClass: function (data) {
      if (!data.isInGroup) {
        return (data.Link) ? 'icon-connect' : 'icon-disconnect'
      }
    },
    getStatus: function (status) {
      if (status.isInGroup) {
        return '--'
      } else {
        if (!status.Shutdown) {
          return this.$t('port.enabled')
        } else {
          return this.$t('port.disabled')
        }
      }
    },
    setTitle: function (data) {
      let title = (data.MediaType === 'fiber' && data.Link && !data.isInGroup) ? this.$t('port.sfpFlowControl') : ''
      return title
    },
    getSpeed: function (data) {
      let link = data.Link
      let value = 'N/A'
      if (!data.isInGroup) {
        if (link) {
          let speed = data.Speed
          if (speed !== 'undefined') {
            let isFDX = (data.FullDuplexStatus) ? ' FDX' : ' HDX'
            value = utility.bytesToSize(speed, 1000) + 'bps' + isFDX
          }
        }
      }
      return value
    },
    getFcStatus: function (data) {
      if (!data.Link || data.MediaType === 'fiber' || data.isInGroup) {
        return '--'
      } else {
        return data.FCstatus ? this.$t('port.enabled') : this.$t('port.disabled')
      }
    },
    getLagFcStatus: function (data) {
      let me = this
      let isFiber = false
      let lagGroup = this.lagGroupMap.get(Number(data.key))
      if (lagGroup) {
        lagGroup.forEach(element => {
          if (me.ports[element - 1].val.MediaType === 'fiber') isFiber = true
        })
      }
      if (!data.val.Link || isFiber || data.isInGroup) {
        return '--'
      } else {
        return data.val.FCstatus ? this.$t('port.enabled') : this.$t('port.disabled')
      }
    },
    setLagTitle: function (data) {
      let me = this
      let isFiber = false
      let lagGroup = this.lagGroupMap.get(Number(data.key))
      if (lagGroup) {
        lagGroup.forEach(element => {
          if (me.ports[element - 1].val.MediaType === 'fiber') isFiber = true
        })
      }
      let title = (isFiber && data.val.Link) ? this.$t('port.sfpFlowControl') : ''
      return title
    },
    getFec (data, link, key) {
      let result
      if (key.val.isInGroup) return '--'
      switch (data) {
        case 'none':
          result = 'None'
          break
        case 'auto':
          result = 'Auto'
          break
        case 'FC_FEC':
          result = 'BASE-R-FEC'
          break
        case 'RS_FEC':
          result = 'RS-FEC'
          break
        case 'N/A':
          result = this.$t('port.notSupTransceiver')
          break
        default:
          result = data
      }
      if (!link) result = '--'
      return result
    },
    getTips: function (key) {
      let num = Number(key)
      let tips = ''
      if (this.portMap.get(num)) {
        tips = this.$t('lag.alreadyJoin')
      }
      return tips
    },
    checkComboPort: function (index) {
      let result = (this.onlySFPlist.indexOf(index + 1) > -1) ? document.getElementById('sfp_' + (parseInt(index) + 1)) : document.getElementById('ethernet_' + (index + 1))
      if (result) {
        if (this.ports[index].val.Combo && this.ports[index].val.MediaType === 'fiber') {
          result = document.getElementById('sfp_' + (parseInt(index) + 1))
        }
      }
      return result
    },
    mouseenter: function (data) {
      let index = data.index
      let imgItem = this.checkComboPort(index)
      if (imgItem) {
        let circelImg = this.$getElementsByClassName(imgItem, 'circle')[0]
        let textImg = this.$getElementsByClassName(imgItem, 'st0')[0]
        circelImg.style.fill = '#FFFF00'
        textImg.style.fill = '#2F2F2F'
      }
    },
    mouseleave: function (data) {
      let index = data.index
      let imgItem = this.checkComboPort(index)
      if (imgItem) {
        let circelImg = this.$getElementsByClassName(imgItem, 'circle')[0]
        let textImg = this.$getElementsByClassName(imgItem, 'st0')[0]
        circelImg.style.fill = '#3B415F'
        textImg.style.fill = '#FFFFFF'
      }
    },
    onInfoClick: function (event, data) {
      if (data.val.Link && data.val.FEC !== 'N/A' && !this.isInfoClick) {
        this.isInfoClick = true
        this.getTransceiver(data.key).then(res => {
          let message = []
          let detail = Object.entries(res.result[0].val)
          let maxlength = 0
          detail.forEach(item => {
            if (item[0].length > maxlength) maxlength = item[0].length
          })
          detail.forEach(item => {
            message.push({text: item[0].padEnd(maxlength) + '\t: ' + item[1]})
          }
          )
          this.$store.commit('updateInfoTips', !this.showInfoTips)
          if (this.showInfoTips) {
            this.$store.commit('updateInfoData', {
              message: message,
              event: event
            })
          }
          this.isInfoClick = false
        })
      }
    },
    getViewStatus: function (data) {
      if (!data.val.Link || data.val.isInGroup) return '--'
      if (data.val.Link && data.val.FEC !== 'N/A') return this.$t('port.view')
      return '--'
    },
    getTitle (id) {
      let el = document.getElementById(id)
      if (el) {
        if (el.offsetWidth < el.scrollWidth) return id
      }
    },
    ...mapActions(['getPortStatus', 'getPortConfigure', 'getTransceiver', 'getFecStatus']),
    ...mapMutations([])
  },
  computed: {
    ...mapState({
      fwinfo: state => state.module.fwinfo,
      sysBoard: state => state.module.sysBoard,
      portNumber: state => state.module.portNum,
      showFullLoading: state => state.module.showFullLoading,
      currentUser: state => state.module.currentUser,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      intervalTime: state => state.app.intervalTime,
      showInfoTips: state => state.app.showInfoTips,
      systemHostInfo: state => state.module.systemHostInfo,
      isFec: state => state.module.isFec
    }),
    onlySFPlist: function () {
      return config.system.sfpPort[this.sysBoard.Product]
    },
    ...mapGetters(['getSwVersion'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>

@import '../assets/scss/login.scss';

.port-status {
  position: relative;
  padding: 20px 15px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .scrollbar-body {
    height: 100%;
  }
  .describe, .group-table {
    margin-right: 15px;
  }
  .title {
    font-family: 'Roboto-M';
    font-size: 14px;
    line-height: 14px;
    margin: 20px 0px;
  }
  .group-table {
    .link-img-content {
      vertical-align: middle;
      display: inline-block;
      font-size: 14px;
      &.icon-connect {
        color: #7ED321;
      }
      &.icon-disconnect {
        color: #979797;
      }
    }
  }
  .detail {
    cursor: pointer;
    text-decoration: underline;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PortStatus.vue